// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    projectsOptions: This.Project[];
    filterProjectId: string | null;
    filterDate: Date | null;
    expenses: This.Expense[];
    stats: { totalCount: number, totalVat: number, totalAmount: number, totalTip: number };
    invoiceId: string;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Llama-InvoicePreparation',
    templateUrl: './InvoicePreparation.html',
    styleUrls: ['./InvoicePreparation.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class InvoicePreparation extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Llama.InvoicePreparation';
    $isDialog = false;
    $Modules = $Modules;
    Llama = Llama;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_7 = (screen: Properties) => ['expenseDate', 'name', 'employee', 'category', 'currency', 'vatAmount', 'tipAmount', 'totalAmount'];
    $validators: Record<number, ValidationRules> = {

    };
    var_projectsOptions = proxySignal<This.Project[]>(undefined as any);
    var_filterProjectId = proxySignal<string | null>(undefined as any);
    var_filterDate = proxySignal<Date | null>(undefined as any);
    var_expenses = proxySignal<This.Expense[]>(undefined as any);
    var_stats = proxySignal<{ totalCount: number, totalVat: number, totalAmount: number, totalTip: number }>(undefined as any);
    var_invoiceId = proxySignal<string>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get projectsOptions() { return component.var_projectsOptions() },
                set projectsOptions(value: This.Project[]) { component.var_projectsOptions.set(value) },
                get filterProjectId() { return component.var_filterProjectId() },
                set filterProjectId(value: string | null) { component.var_filterProjectId.set(value) },
                get filterDate() { return component.var_filterDate() },
                set filterDate(value: Date | null) { component.var_filterDate.set(value) },
                get expenses() { return component.var_expenses() },
                set expenses(value: This.Expense[]) { component.var_expenses.set(value) },
                get stats() { return component.var_stats() },
                set stats(value: { totalCount: number, totalVat: number, totalAmount: number, totalTip: number }) { component.var_stats.set(value) },
                get invoiceId() { return component.var_invoiceId() },
                set invoiceId(value: string) { component.var_invoiceId.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.projectsOptions = ([])
            if (!isVariablesInitialized) this.screen.filterProjectId = (null)
            if (!isVariablesInitialized) this.screen.filterDate = (null)
            if (!isVariablesInitialized) this.screen.expenses = ([])
            if (!isVariablesInitialized) this.screen.stats = ({
                totalCount: 0,
                totalVat: 0,
                totalAmount: 0,
                totalTip: 0
            })
            if (!isVariablesInitialized) this.screen.invoiceId = ('')
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async handler_ButtonBlock_48_click_assignToInvoice_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_assignToInvoice($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DatePickerBlock_14_dateChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_13_selectionChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {
            let selection: any = $event
            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_7(component, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}
                return (screen.expenses)
            }, { equal: () => false })
        )

    }

    _DataTableBlock_additionalFindOptions_7($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({
            where: {
                projectId: screen.filterProjectId || undefined,
                // expenseDate: screen.filter.date,
                isChargeable: true,
                chargedInInvoiceId: null
            }
        })
    }

    _DataTableColumnBlock_cellText_8($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (Sys.Date.format(item.expenseDate, 'dd-MM-yyyy'))
    }

    _DataTableColumnBlock_cellText_9($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.name)
    }

    _DataTableColumnBlock_cellText_51($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.employeeEmail)
    }

    _DataTableColumnBlock_cellText_43($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.category.label)
    }

    _DataTableColumnBlock_cellText_36($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.currency.label)
    }

    _DataTableColumnBlock_cellText_11($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.vatAmount)
    }

    _DataTableColumnBlock_cellText_12($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.tipAmount)
    }

    _DataTableColumnBlock_cellText_10($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.totalAmount)
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.projectsOptions = await This.ExpensesDataStore.loadByCondition(This.Project, {
                where: {
                    isActive: true
                }
            })

            screen.filterDate = Sys.Date.fns.lastDayOfMonth(Sys.Date.fns.subMonths(new Date, 1))

            // await this.action_load($event)
        }
    }

    async action_loadExpenses($event?: any) {
        const { app, screen, output } = this
        {

            if (!screen.filterProjectId) {
                screen.expenses = [];
                return
            }

            screen.expenses = await This.ExpensesDataStore.loadByCondition(This.Expense, {
                where: {
                    projectId: screen.filterProjectId,
                    expenseDate: This.ExpensesDataStore.LessThanOrEqual(screen.filterDate),
                    isChargeable: true,
                    chargedInInvoiceId: This.ExpensesDataStore.IsNull(),
                    status$id: This.ExpenseStatus.verified.id,
                }
            })

            screen.stats = screen.expenses.reduce((acc, item) => {
                return {
                    totalCount: acc.totalCount + 1,
                    totalVat: acc.totalVat + item.vatAmount,
                    totalAmount: acc.totalAmount + item.totalAmount,
                    totalTip: acc.totalTip + item.tipAmount
                }
            }, {
                totalCount: 0,
                totalVat: 0,
                totalAmount: 0,
                totalTip: 0
            })
        }
    }

    async action_assignToInvoice($event?: any) {
        const { app, screen, output } = this
        {
            await This.ExpensesDataStore.updateByCondition(This.Expense, {
                id: This.ExpensesDataStore.In(screen.expenses.map((e) => e.id))
            }, {
                chargedInInvoiceId: screen.invoiceId
            }
            )

            await this.action_loadExpenses($event)
        }
    }
}
